import HomePage from './components/HomePage';
import { MakeGoodProvider } from './context/MakeGoodContext';

const App = () => (
  <div>
    <MakeGoodProvider>
      <HomePage />
    </MakeGoodProvider>
  </div>
);

export default App;
